module.exports = __webpack_public_path__ + "img/product1.6b09628f.png";